import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "startOver",
  "use": "startOver-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"startOver\">\n<path d=\"M15 1.5V6C15 6.5625 14.5312 7 14 7H9.5C8.9375 7 8.5 6.5625 8.5 6C8.5 5.46875 8.9375 5 9.5 5H11.4688C10.5312 3.78125 9.0625 3.03125 7.46875 3.03125C4.71875 3.03125 2.5 5.25 2.5 8C2.5 10.7812 4.71875 13 7.46875 13C8.5625 13 9.59375 12.6562 10.4688 12C10.9062 11.6875 11.5312 11.7812 11.875 12.2188C12.2188 12.6562 12.125 13.2812 11.6875 13.625C10.4688 14.5312 9 15 7.46875 15C3.625 15 0.5 11.875 0.5 8C0.5 4.15625 3.625 1.03125 7.46875 1.03125C9.65625 1.03125 11.6562 2.03125 13 3.71875V1.5C13 0.96875 13.4375 0.5 14 0.5C14.5312 0.5 15 0.96875 15 1.5Z\" fill=\"#26A69A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/startOver.svg
// module id = PLDk
// module chunks = 13